import { createAction } from 'redux-actions';
import { ConfigState } from './types';
import { actionKey } from './constants';

export const initialize = createAction(
  `${actionKey}.INIT`,
  (config: ConfigState) => ({
    config,
  })
);
